import { ResponseCode } from "@app/constants/Common";
import { alertMessage, showMessage } from "@app/constants/Messages";
import { pipelineOptionsToString, pipelineStringToOptions } from "@pages/dvtjcuv/common/PipelineUtil";
import InputCddGPEmpDiscussionContent from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionContent";
import { requestSaveDVTJCUVPipeline } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

export const CddGPEmpDiscussionMode = {
    DEFAULT: 1,
    PAYMENT_AND_WARRANTY: 2
}

const InputCddGPEmpDiscussionModal = (props) => {
    const [pipeline, setPipeline] = useState({});
    const [isAddMode, setAddMode] = useState(true)

    const {pipelineInfo, mode, isShow, onClose} = props

    // const setPipelineInfoForDisplay = (inputPipeline) => {
    //     setPipeline(pipelineStringToOptions(inputPipeline))
    // }

    useEffect(() => {
        if (pipelineInfo) {
            setPipeline(pipelineInfo)
            setAddMode(!pipelineInfo.id)
        } else {
            setPipeline({})
            setAddMode(true)
        }
    }, [isShow, pipelineInfo]);

    const onUpdatePipeLineInfo = () => {
        // Validate
        if (!pipeline.cdd_id) {
            showMessage("Vui lòng nhập Cdd ID")
            return;
        }

        // if (!pipeline.cdd_receiver_id) {
        //     showMessage("Vui lòng nhập Cdd Receiver ID")
        //     return;
        // }

        // Mặc định khi lưu sẽ tạo mới pipeline.
        pipeline.id = "";
        const body = pipelineOptionsToString(pipeline)
        requestSaveDVTJCUVPipeline(body).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(res.sts_code === ResponseCode.SUCCESS)
            } else {
                alertMessage(res.sts_code)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        })
    }

    const onChangeInputItem = (values, column) => {
        pipeline[column.key] = values
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen style={{zIndex: 3002}}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Nhập thông tin GP-Emp-Discussion'}
                    </Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <form onSubmit={(event) => {
                    event.preventDefault();
                    onUpdatePipeLineInfo()
                }}>
                    <Modal.Body>
                        <InputCddGPEmpDiscussionContent
                            mode={mode}
                            onChangeInputItem={onChangeInputItem}
                            pipeLineInfo={pipeline}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type='submit'
                                className='btn btn-primary'
                                // isLoading={isLoading}
                                // disabled={isLoading}
                                // onClick={() => {
                                //     onUpdatePipeLineInfo()
                                // }}
                                >
                            <i className='fas fa-save mr-2'/>
                            Save
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default InputCddGPEmpDiscussionModal;
